var _style, _defs, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledDeviceMedtronic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{mask:url(#mask0_1202_1552_00000106138305792920280240000009845352947273666463_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#939393;}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 20.8,
    height: 28
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 20.8,
    height: 28,
    id: "mask0_1202_1552_00000106138305792920280240000009845352947273666463_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.9,10.1h2v10.1c0,5.4-4.7,9.8-10.4,9.8S6,25.6,6,20.2V10.1h0C6.4,5.6,10.5,2,15.4,2c0.1,0,0.3,0,0.4,0 C16,2,16,2,16.1,2h6.5c1.3,0,2.3,1,2.3,2.3V10.1z M23.6,10.1H7.3c0.4-3.8,3.8-6.8,8.1-6.8c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0 c0,0,0.1,0,0.1,0h6.5c0.5,0,1,0.4,1,1v2h-9.9c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h9.9V10.1z M7.3,20.2v-8.8h2.6v2.5 c-0.4,0.2-0.7,0.6-0.7,1.1c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-0.5-0.3-0.9-0.7-1.1v-2.5h1.6v5.7 c-0.4,0.2-0.7,0.6-0.7,1.1c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-0.5-0.3-0.9-0.7-1.1v-5.7h1.6v2.5 c-0.4,0.2-0.7,0.6-0.7,1.1c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-0.5-0.3-0.9-0.7-1.1v-2.5h1.6v5.7 c-0.4,0.2-0.7,0.6-0.7,1.1c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-0.5-0.3-0.9-0.7-1.1v-5.7h1.6v2.5 C21.2,14.1,21,14.5,21,15c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-0.5-0.3-0.9-0.7-1.1v-2.5h2.6v8.8c0,4.6-4,8.5-9.1,8.5 S7.3,24.8,7.3,20.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledDeviceMedtronic);
export default __webpack_public_path__ + "static/media/disabled-device-medtronic.4a07997fc7cd130bef63f1b0dc487c66.svg";
export { ForwardRef as ReactComponent };